import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';


const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersRef = collection(db, 'users');
        const snapshot = await getDocs(usersRef);
        const userList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUsers(userList);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  // Block user for 24h
  const blockUser = async (userId) => {
    const blockUntil = new Date();
    blockUntil.setHours(blockUntil.getHours() + 24);
    await updateDoc(doc(db, 'users', userId), {
      isBlocked: true,
      blockExpiresAt: blockUntil,
    });
    alert('User blocked for 24 hours.');
    window.location.reload();
  };

  // Unblock user & reset failed attempts
  const unblockUser = async (userId) => {
    await updateDoc(doc(db, 'users', userId), {
      isBlocked: false,
      blockExpiresAt: null,
      failedLoginAttempts: 0,
      failedLoginHistory: []
    });
    alert('User unblocked and failed attempts reset.');
    window.location.reload();
  };

  // Permanently block user
  const permanentlyBlockUser = async (userId) => {
    await updateDoc(doc(db, 'users', userId), {
      isBlocked: true,
      blockExpiresAt: null,
    });
    alert('User permanently blocked.');
    window.location.reload();
  };

  // Clear blockExpiresAt only
  const clearBlockExpiry = async (userId) => {
    try {
      await updateDoc(doc(db, 'users', userId), {
        blockExpiresAt: null
      });
      alert('✅ Block expiry cleared (account remains blocked if isBlocked=true).');
      window.location.reload();
    } catch (error) {
      console.error('Error clearing block expiry:', error);
      alert('❌ Imeshindikana kufuta block expiry. Jaribu tena.');
    }
  };

  if (loading) return <p>Loading users...</p>;

  const filteredUsers = users.filter((user) =>
    user.username?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-users-container">
      <h2>Admin: Manage Users</h2>

      <input
        type="text"
        placeholder="Search by username..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      <table className="users-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Status</th>
            <th>Block Until</th>
            <th>Failed Attempts</th>
            <th>Recent Failed Attempts</th>
            <th>Actions</th>
            <th>Clear Block Expiry</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user) => (
            <tr key={user.id}>
              <td>{user.username || '-'}</td>
              <td>{user.isBlocked ? 'Blocked' : 'Active'}</td>
              <td>
                {user.blockExpiresAt
                  ? new Date(user.blockExpiresAt.toDate ? user.blockExpiresAt.toDate() : user.blockExpiresAt).toLocaleString()
                  : '-'}
              </td>
              <td>{user.failedLoginAttempts || 0}</td>
              <td>
                {user.failedLoginHistory
                  ? user.failedLoginHistory
                      .slice(-5)
                      .map(f => new Date(f.timestamp?.toDate ? f.timestamp.toDate() : f.timestamp).toLocaleString())
                      .join(', ')
                  : '-'}
              </td>
              <td>
                {user.isBlocked ? (
                  <button
                    className="unblock-btn"
                    onClick={() => unblockUser(user.id)}
                  >
                    Unblock & Reset Attempts
                  </button>
                ) : (
                  <>
                    <button
                      className="block-24h-btn"
                      onClick={() => blockUser(user.id)}
                    >
                      Block 24h
                    </button>{' '}
                    <button
                      className="block-perm-btn"
                      onClick={() => permanentlyBlockUser(user.id)}
                    >
                      Block Permanently
                    </button>
                  </>
                )}
              </td>
              <td>
                {user.blockExpiresAt && (
                  <button
                    className="clear-block-btn"
                    onClick={() => clearBlockExpiry(user.id)}
                  >
                    Clear Expiry
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminUsers;